import _objectSpread from "@babel/runtime/helpers/objectSpread";

/**
 * External dependencies
 */
import { numberFormat } from 'i18n-calypso';
/**
 * Internal dependencies
 */

import { getCurrencyDefaults } from './currencies';
export { getCurrencyDefaults };
export { CURRENCIES } from './currencies';
/**
 * Formats money with a given currency code
 * @param   {Number}     number              number to format
 * @param   {String}     code                currency code e.g. 'USD'
 * @param   {Object}     options             options object
 * @param   {String}     options.decimal     decimal symbol e.g. ','
 * @param   {String}     options.grouping    thousands separator
 * @param   {Number}     options.precision   decimal digits
 * @param   {String}     options.symbol      currency symbol e.g. 'A$'
 * @returns {?String}                        A formatted string.
 */

export default function formatCurrency(number, code) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var currencyDefaults = getCurrencyDefaults(code);

  if (!currencyDefaults || isNaN(number)) {
    return null;
  }

  var _currencyDefaults$opt = _objectSpread({}, currencyDefaults, options),
      decimal = _currencyDefaults$opt.decimal,
      grouping = _currencyDefaults$opt.grouping,
      precision = _currencyDefaults$opt.precision,
      symbol = _currencyDefaults$opt.symbol;

  var sign = number < 0 ? '-' : '';
  var value = numberFormat(Math.abs(number), {
    decimals: precision,
    thousandsSep: grouping,
    decPoint: decimal
  });
  return "".concat(sign).concat(symbol).concat(value);
}
/**
 * Returns a formatted price object.
 * @param   {Number}     number              number to format
 * @param   {String}     code                currency code e.g. 'USD'
 * @param   {Object}     options             options object
 * @param   {String}     options.decimal     decimal symbol e.g. ','
 * @param   {String}     options.grouping    thousands separator
 * @param   {Number}     options.precision   decimal digits
 * @param   {String}     options.symbol      currency symbol e.g. 'A$'
 * @returns {?String}                        A formatted string e.g. { symbol:'$', integer: '$99', fraction: '.99', sign: '-' }
 */

export function getCurrencyObject(number, code) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var currencyDefaults = getCurrencyDefaults(code);

  if (!currencyDefaults || isNaN(number)) {
    return null;
  }

  var _currencyDefaults$opt2 = _objectSpread({}, currencyDefaults, options),
      decimal = _currencyDefaults$opt2.decimal,
      grouping = _currencyDefaults$opt2.grouping,
      precision = _currencyDefaults$opt2.precision,
      symbol = _currencyDefaults$opt2.symbol;

  var sign = number < 0 ? '-' : '';
  var absNumber = Math.abs(number);
  var rawInteger = Math.floor(absNumber);
  var integer = numberFormat(rawInteger, {
    decimals: 0,
    thousandsSep: grouping,
    decPoint: decimal
  });
  var fraction = precision > 0 ? numberFormat(absNumber - rawInteger, {
    decimals: precision,
    thousandsSep: grouping,
    decPoint: decimal
  }).slice(1) : '';
  return {
    sign: sign,
    symbol: symbol,
    integer: integer,
    fraction: fraction
  };
}